<template>
  <div>
    <div class="h1">
      <div class="w">
        <div class="zhuanpan">
          <!-- v-bind:class="{ 'dianji': dianji }" -->
          <img
            @click="dianji"
            :class="dianjis ? 'dianji' : ''"
            src="../../assets/img/market/market105/zhizhen1.png"
            alt=""
          />
        </div>
      </div>
    </div>
    <div class="divBG" v-if="tan">
      <div class="content">
        <img
          class="btnss"
          src="../../assets/img/market/market105/1000元代金券.png"
          alt=""
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      phone: "",
      dianjis: false,
      tan: false
    };
  },
  mounted() {},
  methods: {
    dianji() {
      const that = this;
      this.dianjis = true;
      setTimeout(function() {
        console.log(2);
      }, 1000);
    },
    btns() {
      var re = /^1[3-9]{1}[0-9]{9}$/;
      if (re.test(this.phone)) {
        this.$router.push({ path: "/market106" });
      } else {
        alert("请输入正确格式的手机号");
        this.phone = "";
      }
    }
  }
};
</script>
<style lang="less" scoped>
* {
  font-size: 0.16rem;
}

.dianji {
  transform: rotate(3580deg);
  transform-origin: 50% 50%;
  transition: all 5s;
  transition-timing-function: ease-in-out;
}

.divBG {
  z-index: 999;
  background-color: rgba(31, 30, 30, 0.6);
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 20;

  .content {
    width: 1rem;
    margin: 0 auto;
    position: relative;

    .btnss {
      position: absolute;
      top: 3.46rem;
      left: -2.3rem;
      z-index: 999;
      width: 5.6rem;
      height: 6.98rem;
    }
  }
}

.h1 {
  width: 100%;
  height: 13.34rem;
  background: url(../../assets/img/market/market105/zhuan_bg.png) no-repeat
    center;
  background-size: 100% 100%;
  position: relative;

  .w {
    width: 6.27rem;
    margin: 0 auto;
    padding-top: 2.73rem;

    .zhuanpan {
      width: 6.27rem;
      height: 6.27rem;
      background: url(../../assets/img/market/market105/zhuanpan2.png) no-repeat
        center;
      background-size: 100% 100%;
      position: relative;

      img {
        width: 1.78rem;
        // height: 1.90rem;
        height: 2.02rem;
        position: absolute;
        top: 50%;
        left: 50%;
        margin-top: -0.89rem;
        margin-left: -0.85rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/market/market106.vue